export default __webpack_public_path__ + "static/website-06ea7ed0ec54db9f8a16d6b8edde98f4.svg";